var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileIconGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "20px",
    viewBox: "0 0 13 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6 Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logged-In-Devices",
    transform: "translate(-431.000000, -551.000000)",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(432.000000, 552.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0956913,13.6 L0.740316478,13.6 L0.740316478,1.4 C0.740316478,0.988 1.11839859,0.654 1.58477533,0.654 L10.2512325,0.654 C10.7176092,0.654 11.0956913,0.988 11.0956913,1.4 L11.0956913,13.6 Z M11.0956913,16.6 C11.0956913,17.012 10.7176092,17.346 10.2512325,17.346 L1.58477533,17.346 C1.11839859,17.346 0.740316478,17.012 0.740316478,16.6 L0.740316478,14.256 L11.0956913,14.256 L11.0956913,16.6 Z M10.2512325,0 L1.58477533,0 C0.709526557,0 0,0.6268 0,1.4 L0,16.6 C0,17.3732 0.709526557,18 1.58477533,18 L10.2512325,18 C11.1264812,18 11.8360078,17.3732 11.8360078,16.6 L11.8360078,1.4 C11.8360078,0.6268 11.1264812,0 10.2512325,0 L10.2512325,0 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,15.5888689 C6.22710952,15.5888689 6.41113106,15.7728905 6.41113106,16 C6.41113106,16.2271095 6.22710952,16.4111311 6,16.4111311 C5.77289048,16.4111311 5.58886894,16.2271095 5.58886894,16 C5.58976661,15.7732496 5.77324955,15.5897666 6,15.5888689 M6,17 C6.55224417,17 7,16.5522442 7,16 C7,15.4477558 6.55224417,15 6,15 C5.44775583,15 5,15.4477558 5,16 C5.0010772,16.5518851 5.4481149,16.9989228 6,17",
    id: "Fill-4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIconGrey);
export default __webpack_public_path__ + "static/media/mobile-icon-grey.70ca55fedb1d66ade91ec4e176b5fead.svg";
export { ForwardRef as ReactComponent };